var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandlestickDoodles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .candle { stroke: black; stroke-width: 3; fill: none; stroke-linecap: round; stroke-linejoin: round; }\n    .fill-black { fill: black; }\n    .fill-white { fill: white; }\n    .text { font-family: sans-serif; font-size: 14px; text-anchor: middle; font-weight: bold;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -40,
    x2: 0,
    y2: 40,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -10,
    width: 30,
    height: 20,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: -40,
    x2: 60,
    y2: 40,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: -10,
    width: 30,
    height: 20,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 70,
    className: "text"
  }, "Spinning Tops"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -50,
    x2: 0,
    y2: 20,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 10,
    width: 30,
    height: 25,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    className: "text"
  }, "Shooting Star"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -20,
    x2: 0,
    y2: 50,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -35,
    width: 30,
    height: 25,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    className: "text"
  }, "Hammer"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500, 100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -40,
    x2: 0,
    y2: 40,
    className: "candle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: 0,
    x2: 15,
    y2: 0,
    className: "candle"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    className: "text"
  }, "Doji"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -20,
    y1: -20,
    x2: -20,
    y2: 30,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -10,
    width: 20,
    height: 30,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: -50,
    x2: 20,
    y2: 40,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -40,
    width: 30,
    height: 70,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 80,
    className: "text"
  }, "Bullish Engulfing"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 250)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -20,
    y1: -30,
    x2: -20,
    y2: 20,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -20,
    width: 20,
    height: 30,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: -40,
    x2: 20,
    y2: 50,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -30,
    width: 30,
    height: 70,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    className: "text"
  }, "Bearish Engulfing"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 250)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: -30,
    x2: -40,
    y2: 30,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -20,
    width: 20,
    height: 40,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -40,
    x2: 0,
    y2: -10,
    className: "candle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    y1: -30,
    x2: 10,
    y2: -30,
    className: "candle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: -20,
    x2: 40,
    y2: 30,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: -10,
    width: 20,
    height: 30,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    className: "text"
  }, "Evening Star"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(420, 250)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: -30,
    x2: -40,
    y2: 30,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -20,
    width: 20,
    height: 40,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 0,
    y2: 50,
    className: "candle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    y1: 40,
    x2: 10,
    y2: 40,
    className: "candle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: -20,
    x2: 40,
    y2: 30,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: -10,
    width: 20,
    height: 30,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    className: "text"
  }, "Morning Star"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(560, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 10,
    width: 20,
    height: 30,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: 5,
    x2: -30,
    y2: 45,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -20,
    width: 20,
    height: 30,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -25,
    x2: 0,
    y2: 15,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -50,
    width: 20,
    height: 30,
    className: "candle fill-white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: -55,
    x2: 30,
    y2: -15,
    className: "candle"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    className: "text"
  }, "3 Soldiers"))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(680, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -40,
    width: 20,
    height: 30,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: -45,
    x2: -30,
    y2: -5,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -10,
    width: 20,
    height: 30,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -15,
    x2: 0,
    y2: 25,
    className: "candle"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 30,
    className: "candle fill-black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 15,
    x2: 30,
    y2: 55,
    className: "candle"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    className: "text"
  }, "3 Crows"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandlestickDoodles);
export default __webpack_public_path__ + "static/media/candlestick-doodles.9e4d460b30812f2d3b23059ea8b8cafa.svg";
export { ForwardRef as ReactComponent };